export default __webpack_public_path__ + "static/media/discord.33c54835.svg";